"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initTableWithToggleableColumns = void 0;
var resizable_columns_1 = require("./resizable-columns");
function initTableWithToggleableColumns(table) {
    setDataAttributesToCells(table);
    createHeadersMenu(table);
    hideColumnsOnLoading(table);
    var headersRow = table.querySelector('tr');
    headersRow.addEventListener('contextmenu', function (e) { return showHeadersMenu(table, e); });
    var headersMenu = table.parentElement.querySelector('.headers-menu');
    headersMenu.addEventListener('click', function (e) { return handleHeadersMenuClick(table, e); });
}
exports.initTableWithToggleableColumns = initTableWithToggleableColumns;
function createHeadersMenu(table) {
    var columns = (0, resizable_columns_1.getTableColumns)(table);
    var menu = document.createElement("div");
    menu.classList.add("headers-menu", "hidden");
    var list = document.createElement("ul");
    list.classList.add("headers-menu__list");
    columns.forEach(function (column) {
        var li = document.createElement('li');
        var label = document.createElement('label');
        var span = document.createElement('span');
        span.classList.add('checkmark');
        var columnId = (0, resizable_columns_1.getColumnId)(column);
        var checkbox = document.createElement('input');
        checkbox.setAttribute('type', 'checkbox');
        checkbox.setAttribute('data-column-id', columnId);
        checkbox.checked = !(0, resizable_columns_1.isHiddenColumn)(column);
        var columnTitle = (column.innerText ? column.innerText : columnId.replace(/_/g, " ")).toLowerCase();
        var text = document.createTextNode(columnTitle);
        label.appendChild(text);
        label.appendChild(checkbox);
        label.appendChild(span);
        li.appendChild(label);
        list.appendChild(li);
    });
    menu.append(list, getResetButton());
    table.parentElement.insertBefore(menu, table.nextElementSibling);
}
function getResetButton() {
    var resetButton = document.createElement("button");
    resetButton.classList.add("reset-button", "headers-menu__button");
    resetButton.innerText = "Reset config";
    return resetButton;
}
function hideColumnsOnLoading(table) {
    (0, resizable_columns_1.getTableColumns)(table)
        .filter(function (column) { return (0, resizable_columns_1.isHiddenColumn)(column); })
        .forEach(function (column) { return hideColumn(table, (0, resizable_columns_1.getColumnId)(column)); });
}
function showHeadersMenu(table, e) {
    var tableWrapper = table.parentElement;
    var headersMenu = tableWrapper.querySelector('.headers-menu');
    var x = e.clientX - tableWrapper.getBoundingClientRect().left;
    var y = e.clientY - tableWrapper.getBoundingClientRect().top;
    tableWrapper.style.position = 'relative';
    headersMenu.style.top = "".concat(y, "px");
    headersMenu.style.left = "".concat(x, "px");
    headersMenu.classList.remove('hidden');
    var documentClickHandler = function (e) {
        if (e.target instanceof HTMLElement) {
            var isClickedOutside = !headersMenu.contains(e.target);
            if (isClickedOutside) {
                headersMenu.classList.add('hidden');
                document.removeEventListener('click', documentClickHandler);
            }
        }
    };
    document.addEventListener('click', documentClickHandler);
    e.preventDefault();
}
function setDataAttributesToCells(table) {
    setDataColumnIdsToCells(table);
    setTrueDataShownToALLCells(table);
    setFalseDataShownToHiddenCells(table);
}
function setTrueDataShownToALLCells(table) {
    var cells = getCells(table);
    for (var _i = 0, cells_1 = cells; _i < cells_1.length; _i++) {
        var cell = cells_1[_i];
        cell.setAttribute('data-shown', 'true');
    }
}
function setFalseDataShownToHiddenCells(table) {
    var hiddenColumnIds = getHiddenColumnIds(table);
    getCells(table)
        .filter(function (cell) { return hiddenColumnIds.includes((0, resizable_columns_1.getColumnId)(cell)); })
        .forEach(function (cell) { return cell.setAttribute('data-shown', 'false'); });
}
function setDataColumnIdsToCells(table) {
    var cellsButHeaders = getCellsButHeaders(table);
    var columnIds = getColumnIdsConsideringColspan(table);
    var columnCount = columnIds.length;
    cellsButHeaders.forEach(function (cell, index) {
        var columnId = columnIds[index % columnCount];
        cell.setAttribute('data-column-id', columnId);
    });
}
function getCells(table) {
    return Array.from(table.querySelectorAll('th, td'));
}
function getCellsButHeaders(table) {
    var columns = (0, resizable_columns_1.getTableColumns)(table);
    return getCells(table).splice(columns.length);
}
function getHiddenColumnIds(table) {
    var columns = (0, resizable_columns_1.getTableColumns)(table);
    var columnRatios = (0, resizable_columns_1.getTableProperties)(table).columnRatios;
    var hiddenColumnIds = [];
    for (var _i = 0, columns_1 = columns; _i < columns_1.length; _i++) {
        var column = columns_1[_i];
        var columnId = (0, resizable_columns_1.getColumnId)(column);
        if (columnRatios[columnId] === 0) {
            hiddenColumnIds.push(columnId);
        }
    }
    return hiddenColumnIds;
}
function getColumnIdsConsideringColspan(table) {
    var columns = (0, resizable_columns_1.getTableColumns)(table);
    var columnIds = [];
    for (var _i = 0, columns_2 = columns; _i < columns_2.length; _i++) {
        var column = columns_2[_i];
        var columnId = (0, resizable_columns_1.getColumnId)(column);
        var columnColspan = parseFloat(column.getAttribute('colspan'));
        if (columnColspan) {
            for (var i = columnColspan; i > 0; i--) {
                columnIds.push(columnId);
            }
        }
        else {
            columnIds.push(columnId);
        }
    }
    return columnIds;
}
function handleHeadersMenuClick(table, e) {
    var target = e.target;
    if (target instanceof HTMLElement) {
        if (target instanceof HTMLInputElement) {
            toggleColumn(table, e);
        }
        else if (target.closest(".reset-button")) {
            resetTable(table);
        }
    }
}
function toggleColumn(table, e) {
    if (e.target instanceof HTMLInputElement && e.target.getAttribute('data-column-id')) {
        var columnId = e.target.getAttribute('data-column-id');
        e.target.checked ? showColumn(table, columnId) : hideColumn(table, columnId);
        var tableProperties = recalculateTablePropertiesDueToToggleColumn(table, columnId);
        (0, resizable_columns_1.setColumnWidths)(table, tableProperties);
    }
}
function resetTable(table) {
    (0, resizable_columns_1.clearLocalStorageTableProperties)(table);
    document.location.reload();
}
function showColumn(table, id) {
    var cells = getCells(table);
    cells
        .filter(function (cell) { return (0, resizable_columns_1.getColumnId)(cell) === id; })
        .forEach(function (cell) {
        cell.classList.remove('hidden');
        cell.setAttribute('data-shown', 'true');
    });
    lockOrUnlockCheckboxes(table);
}
function hideColumn(table, id) {
    var cells = getCells(table);
    cells
        .filter(function (cell) { return (0, resizable_columns_1.getColumnId)(cell) === id; })
        .forEach(function (cell) {
        cell.classList.add('hidden');
        cell.setAttribute('data-shown', 'false');
    });
    lockOrUnlockCheckboxes(table);
}
function lockOrUnlockCheckboxes(table) {
    var visibleResizableColumns = (0, resizable_columns_1.getResizableColumnsByColumns)((0, resizable_columns_1.getVisibleColumns)(table));
    for (var _i = 0, visibleResizableColumns_1 = visibleResizableColumns; _i < visibleResizableColumns_1.length; _i++) {
        var column = visibleResizableColumns_1[_i];
        var columnId = (0, resizable_columns_1.getColumnId)(column);
        var columnCheckbox = document.querySelector("[type=checkbox][data-column-id='".concat(columnId, "']"));
        if (visibleResizableColumns.length === 1) {
            columnCheckbox.setAttribute('disabled', 'true');
        }
        else if (visibleResizableColumns.length > 1) {
            columnCheckbox.removeAttribute('disabled');
        }
    }
}
// Get recalculated ratios when column hides or shows
function recalculateTablePropertiesDueToToggleColumn(table, columnId) {
    var tableProperties = (0, resizable_columns_1.getTableProperties)(table);
    var columnRatios = tableProperties.columnRatios;
    var columns = (0, resizable_columns_1.getTableColumns)(table);
    var targetColumn = columns.find(function (column) { return (0, resizable_columns_1.getColumnId)(column) === columnId; });
    var targetColumnId = (0, resizable_columns_1.getColumnId)(targetColumn);
    var targetColumnMinWidth = (0, resizable_columns_1.getColumnMinWidth)(targetColumn);
    var isShownTargetColumn = !(0, resizable_columns_1.isHiddenColumn)(targetColumn);
    if (isShownTargetColumn) {
        var targetColumnMinRatio = (0, resizable_columns_1.getColumnRatioFromWidth)(targetColumnMinWidth, tableProperties.tableWidth);
        columnRatios[targetColumnId] = targetColumnMinRatio;
        var columnRatiosSum = columns.reduce(function (acc, column) { return acc + columnRatios[(0, resizable_columns_1.getColumnId)(column)]; }, 0);
        while (columnRatiosSum > 100) {
            var maxColumnId = Object.keys(columnRatios)
                .reduce(function (prevKey, curKey) { return columnRatios[prevKey] > columnRatios[curKey] ? prevKey : curKey; });
            var changeRatioStep = 0.1;
            columnRatios[maxColumnId] -= changeRatioStep;
            columnRatiosSum -= changeRatioStep;
        }
    }
    else {
        var visibleResizableColumnsExceptTarget = (0, resizable_columns_1.getVisibleColumns)(table)
            .filter(function (column) { return (0, resizable_columns_1.isAutoResizableColumn)(column); })
            .filter(function (column) { return column !== targetColumn; });
        for (var _i = 0, visibleResizableColumnsExceptTarget_1 = visibleResizableColumnsExceptTarget; _i < visibleResizableColumnsExceptTarget_1.length; _i++) {
            var column = visibleResizableColumnsExceptTarget_1[_i];
            var columnId_1 = (0, resizable_columns_1.getColumnId)(column);
            columnRatios[columnId_1] += columnRatios[targetColumnId] / visibleResizableColumnsExceptTarget.length;
        }
        columnRatios[targetColumnId] = 0;
    }
    tableProperties.columnRatios = columnRatios;
    return tableProperties;
}
//# sourceMappingURL=toggleable-columns.js.map